<gcm-loading></gcm-loading>
<tour-step-template></tour-step-template>
<div class="w-full" id="{{containerId}}">
  <router-outlet></router-outlet>
  @if (timeoutService.sessiontimeout) {
    <div>
      <app-session></app-session>
    </div>
  }
</div>